<template>
  <div style="height: 100%" class="detail">
    <Layout>
      <Sider hide-trigger width="260">
        <Input v-model="search" icon="ios-search" style="width: 200px"></Input>
        <Tree :data="list" @on-select-change="select"></Tree>
      </Sider>
      <Layout>
        <Content class="content">
          <h2 style="text-align:center;margin-bottom: 20px">{{detail.title}}</h2>
          <span>发布时间：{{detail.addDate}}</span>
          <span style="margin-left: 30px">摘要：{{detail.summary}}</span>
          <p style="margin-top: 20px" v-html="detail.content"></p>
        </Content>
      </Layout>
    </Layout>
    <div slot="footer"></div>
  </div>
</template>
<script>
import axios from 'axios'
import requestUrls from '@/lib/requestUrls'
import { setTimeout } from 'timers';

var apiKey = '6dc99789-2448-4f11-9bfa-e6600366c6cb'
var siteId = '2139'

export default {
  props: {
    data: Object,
    fullList: Array
  },
  data() {
    return {
      list: [],
      detail: {
        addDate: '',
        summary: '',
        content: ''
      },
      search: '',
      arrow: ''
    };
  },
  created() {
    this.list = this.fullList
  },
  watch: {
    data(val) {
      this.detail = val
      // console.log(val)
      if (val.channelId == 4348) {  // 操作指南
        this.list[1].children.forEach((li,index) => {
          if(li.children) {
            li.children.forEach(item => {
              if (item.title.indexOf(val.title) != -1) {
                // 展开对应菜单
                this.$set(item, 'selected', true)
                this.$set(this.list[1], 'expand', true)
                this.$set(this.list[1].children[index], 'expand', true)
              } else {
                this.$set(item, 'selected', false)
              }
            })
          }
        })
      } else {
        this.list.forEach((li,index) => {
          if(li.children) {
            li.children.forEach(item => {
              if (item.title === val.title) {
                // 展开对应菜单
                this.$set(item, 'selected', true)
                this.$set(this.list[index], 'expand', true)
              } else {
                this.$set(item, 'selected', false)
              }
            })
          }
        })
      }
    },
    search(val) {
      this.list = []
      if (!val) {
        this.list = this.fullList
        // this.fullList.forEach(li => {
        //   // this.$set(li, 'expand', false)
        //   li.children.forEach(item => {
        //     this.$set(item, 'selected', false)
        //   })
        // })
      } else {
        this.fullList.forEach(async(li,index) => {
          for(let i = 0; i < li.children.length; i++) {
            if (li.children[i].title.indexOf(val) !== -1) {
              this.$set(this.fullList[index], 'expand', true)
              // this.$set(li.children[i], 'selected', true)
              this.list.push(this.fullList[index])
              // 去重
              let map = new Map()
              this.list = await this.list.filter((item) => !map.has(item.title) && map.set(item.title, 1))
              setTimeout(() => {
                // 获取所有树子节点
                let treeNode = document.querySelectorAll('ul.ivu-tree-children ul.ivu-tree-children span.ivu-tree-title')
                for (let j = 0; j < treeNode.length; j++) {
                  if (treeNode[j].innerText.indexOf(val) !== -1) {
                    treeNode[j].className = treeNode[j].className + ' bg'
                  }
                }
              },300)
            }
          }
        })
      }
    }
  },
  methods: {
    change(show) {
      if (!show) {
        this.$emit('close')
      }
    },
    select(val) {
      if (val[0]&&!val[0].children) {
        this.detail = val[0]
        this.$emit('dataChange',val[0])
        let url = 'http://www.chinapsp.cn'
        if (!this.detail.content.match(url)) {
          let arr = this.detail.content.match(/<img(.*?)src="(.*?)"(.*?)\/>/g)
          if (arr != null) {
            arr.forEach((item,index) => {
              this.detail.content = this.detail.content.replace(item,item.slice(0,10) + url + item.slice(10))
            })
          }
        }
      } else {
        // 点击节点名称展开/收起子节点
        if (val[0]) {
          setTimeout(() => {
            let title = document.querySelector('span.ivu-tree-title-selected')
            this.arrow = title.previousElementSibling
            this.arrow.click()
          },0)
        } else {
          this.arrow.click()
        }
      }
    }
  }
}
</script>
<style lang="less">
.detail {
  .ivu-layout-sider {
    padding: 20px;
    background-color: #fff;
    overflow: auto;
  }
  .ivu-layout {
    height: 100%;
    overflow: hidden;
  }
  .content {
    background-color: #fff;
    font-size: 14px;
    border-left:1px solid #e9eaec;
    padding: 20px;
    overflow: auto;
  }
  .ivu-tree li ul {
    padding-left: 14px;
  }
  .ivu-tree-title {
    font-size: 14px;
  }
}
.bg {
  background-color: #FFFF66;
}
</style>
